import { Stack, Typography, styled } from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
// import Regeneratepopup from "../MailComponent/Regenratepopup";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { format, parseISO } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import { handleClosureLoading, handleGenerateClosure } from "../Redux/Closure";
import { fetchCampaignsData, handleCampainIDSelection, resetSubmissionButton } from "../Redux/Mailer";
import ClosureDataDisplay from "./closureDataDisplay";
import "./closureForm.css";
const CustomRadio = styled(Radio)(({
  theme
}) => ({
  "&.Mui-checked": {
    color: "#9c27b0" // Purple for the checked state
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.5rem" // Custom icon size
  },
  "&:hover": {
    backgroundColor: "rgba(156, 39, 176, 0.08)" // Optional hover effect
  }
}));
const WhiteBorderTextField = styled(TextField)`
 & label.Mui-focused {
  color: #a804ff;
 }
 & .MuiOutlinedInput-root {
  &.Mui-focused fieldset {
   border-color: #a814ff;
   border-width: 1px;
  }
 }
`;
const ClosureForm = ({
  programList,
  campaigns,
  categoryNameClosure,
  setCategoryNameClosure,
  mailerChild,
  setMailerChild,
  setMailerParent,
  mailerParent
}) => {
  const [programNameClosure, setProgramNameClosure] = useState("");
  const [keyMsgClosure, setKeyMsgClosure] = useState("");
  const [startDatesClosure, setStartDatesClosure] = useState();
  const [endDatesClosure, setEndDatesClosure] = useState();
  const [campaign, setCampaign] = useState(0);
  const campaignList = useSelector(state => state.model.campaignList);
  const options = campaignList.message !== "No campaign for this user." && campaignList.length > 0 ? campaignList.map(item => ({
    id: item.id,
    name: item.name
  })) : [];
  const [additionalResourcesClosure, setAdditionalResourcesClosure] = useState("");
  const [isClosureMailGenerationClicked, setIsClosureGenerationClicked] = React.useState(false);
  const [isClosureNavigatedToForm, setIsClosureNavigatedToForm] = useState(false);
  const isClosureLoaded = useSelector(state => state.closure.isClosureLoaded);
  const dispatch = useDispatch();
  const [isClosureMailGenerated, setIsClosureMailGenerated] = useState("init");
  const handleCampaignID = val => {
    if (val) {
      setCampaign(val.id);
      let campaignID = val.id;
      let data = campaignList.filter(val => val.id == campaignID);
      setProgramNameClosure(data[0].name);
      const item = data[0].selectedItems.filter(val => val.title == "Learning Journey Start");
      const lastDateItem = data[0].selectedItems.filter(val => val.title == "Learning Journey End");
      let initialDate;
      let lastDate;
      if (item.length != 0) {
        initialDate = format(parseISO(item[0].date), "yyyy-MM-dd");
      } else {
        initialDate = "";
      }
      if (lastDateItem.length != 0) {
        lastDate = format(parseISO(lastDateItem[0].date), "yyyy-MM-dd");
      } else {
        lastDate = "";
      }
      setStartDatesClosure(initialDate);
      setEndDatesClosure(lastDate);
      dispatch(handleCampainIDSelection(campaignID));
    }
  };
  const [value, setValue] = React.useState(null);
  useEffect(() => {
    dispatch(fetchCampaignsData(categoryNameClosure));
  }, []);
  const handleChange = event => {
    if (event.target.value == "no") {
      setCampaign(0);
      dispatch(handleCampainIDSelection(0));
    }
    handleRadioChangeReset();
    setValue(event.target.value);
  };
  const today = new Date().toISOString().split("T")[0];
  const handleReset = () => {
    dispatch(resetSubmissionButton());
    setMailerChild("");
    setMailerParent("");
    setCategoryNameClosure("Program");
    setProgramNameClosure("");
    setStartDatesClosure("");
    setEndDatesClosure("");
    setKeyMsgClosure("");
    setAdditionalResourcesClosure("");
    setValue("");
  };
  const handleRadioChange = e => {
    setCategoryNameClosure(e.target.value);
    setValue("");
    dispatch(fetchCampaignsData(e.target.value));
    handleRadioChangeReset();
  };
  const handleRadioChangeReset = () => {
    dispatch(resetSubmissionButton());
    setProgramNameClosure("");
    setStartDatesClosure("");
    setEndDatesClosure("");
    setKeyMsgClosure("");
    setAdditionalResourcesClosure("");
    setCampaign(0);
    setIsClosureMailGenerated("init");
    setIsClosureNavigatedToForm(false);
  };
  const handleClosureMailGeneration = () => {
    setIsClosureGenerationClicked(true);
    let values = {
      programNameClosure: programNameClosure,
      startDatesClosure: startDatesClosure,
      endDatesClosure: endDatesClosure,
      additionalResourcesClosure: additionalResourcesClosure,
      keyMsgClosure: keyMsgClosure,
      currentContent: "",
      sessionID: localStorage.getItem("sessionId"),
      categoryName: categoryNameClosure
    };
    dispatch(handleGenerateClosure(values));
  };
  const HtmlTooltip = styled(({
    className,
    ...props
  }) => <Tooltip {...props} classes={{
    popper: className
  }} />)(({
    theme
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9"
    }
  }));
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 200
      }
    }
  };
  return <>
   {!isClosureMailGenerationClicked ? <Stack>
     <Stack sx={{
        width: "100%"
      }}>
      <WelcomeNameContainer currentComp="Closure" />
      <Stack spacing={1} className="mail-form-container-stack">
       <div className="mail-form-container">
        <div className="mailer-form-categories-section">
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Learning Program</span>
          <input type="radio" checked={categoryNameClosure === "Program"} value="Program" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Event</span>
          <input type="radio" checked={categoryNameClosure === "Event"} value="Event" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>

         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Webinar</span>
          <input type="radio" checked={categoryNameClosure === "Webinar"} value="Webinar" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
        </div>
        <Stack direction={"row"} sx={{
              alignItems: "flex-start"
            }} spacing={2}>
         <Stack direction={"row"} sx={{
                alignItems: "flex-start"
              }} spacing={2}>
          <Stack direction={"column"}>
           <Typography>
            Is this communication part of any campaign?{" "}
            <span className="migrated-style-closureform-318e74-1">*</span>
           </Typography>
           <Typography>(If yes, select the campaign name)</Typography>
          </Stack>

          <FormControl>
           <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={value} onChange={handleChange} sx={{
                    paddingLeft: "20px"
                  }}>
            <FormControlLabel value="yes" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-closureform-318e74-2" />} // Empty circle when unchecked
                    checkedIcon={<CheckCircleOutlineIcon className="migrated-style-closureform-318e74-3" />} // Checkmark inside circle when checked
                    />} label="Yes" />
            <FormControlLabel value="no" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-closureform-318e74-4" />} // Empty circle when unchecked
                    checkedIcon={<CheckCircleOutlineIcon className="migrated-style-closureform-318e74-5" />} // Checkmark inside circle when checked
                    />} label="No" />
           </RadioGroup>
          </FormControl>
         </Stack>
         {value == "yes" && <Stack direction={"row"} sx={{
                alignItems: "center"
              }} spacing={2}>
           <Typography>
            Select the campaign <span className="migrated-style-closureform-318e74-6">*</span>
           </Typography>
           <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px",
                  m: 1,
                  width: 200,
                  mt: 3
                }} direction={"row"} spacing={2}>
            {/* <Select value={campaign} onChange={handleCampaignID} MenuProps={MenuProps}>
             {campaignList.message != "No campaign for this user." &&
              campaignList.length > 0 &&
              campaignList.map((item, index) => (
               <MenuItem key={index + 1} value={item.id}>
                {item.name}
               </MenuItem>
              ))}
             </Select> */}
            <Autocomplete value={options.find(option => option.id === campaign) || null} onChange={(event, newValue) => {
                    handleCampaignID(newValue);
                  }} options={options} getOptionLabel={option => option.name || ""} ListboxProps={{
                    style: {
                      maxHeight: "150px",
                      // Fixed height for the dropdown
                      overflowY: "auto" // Enable vertical scrolling
                    }
                  }} renderInput={params => <TextField sx={{
                    "& .MuiOutlinedInput-root": {
                      padding: "2px !important"
                    }
                  }} {...params} variant="outlined" />} filterSelectedOptions={false} />
           </Stack>
          </Stack>}
        </Stack>
        <div className="mail-form-wrap">
         <div className="mail-form-inner-wrap">
          <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px"
                }}>
           <Typography sx={{
                    fontSize: "16px"
                  }}>
            <span>
             Name<span className="migrated-style-closureform-318e74-7">*</span>
            </span>
            <HtmlTooltip arrow title={<React.Fragment>
               {categoryNameClosure == "Program" ? <p> Enter the program name </p> : categoryNameClosure == "Event" ? <p> Enter the event name</p> : categoryNameClosure == "Microsite/Tool/Platform" ? <p> Enter the Microsite/Tool/Platform name</p> : <p> Enter the Webinar name</p>}
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-closureform-318e74-8" />
            </HtmlTooltip>
           </Typography>
           {/* <WhiteBorderTextField
            placeholder={
             categoryNameClosure == "Program"
              ? "e.g: Java Full Stack"
              : categoryNameClosure == "Event"
              ? "e.g: Google Cloud Fusion Fest"
              : "e.g: Azure Open AI Security"
            }
            id="multiline"
            multiline
            minRows={1}
            maxRows={2}
            disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            value={programNameClosure}
            InputLabelProps={{ shrink: false }}
            InputProps={{
             readOnly: value === "yes" && campaign != 0,
            }}
            onChange={(event) => {
             setProgramNameClosure(event.target.value);
             setIsClosureMailGenerated("init");
            }}
            fullWidth
            /> */}
                <Autocomplete id="free-solo-demo" freeSolo value={programNameClosure} onChange={(event, newValue) => {
                    setProgramNameClosure(newValue || ""); // Ensure value updates when selecting a suggestion
                    setIsClosureMailGenerated("init");
                  }} onInputChange={(event, newInputValue) => {
                    setProgramNameClosure(newInputValue); // Update state when typing
                  }} disabled={!value || value === "yes"} inputprops={{
                    readOnly: value === "yes"
                  }} options={programList.map(option => option.programname)} renderInput={params => <WhiteBorderTextField {...params} id="multiline" multiline minRows={1} maxRows={2} fullWidth placeholder={categoryNameClosure === "Program" ? "e.g: Java Full Stack" : categoryNameClosure === "Event" ? "e.g: ATCI Event" : categoryNameClosure === "Microsite/Tool/Platform" ? "e.g: ATCI Learning" : "e.g: ATCI Webinar"} disabled={!value || value === "yes" && campaign === 0} />} />
          </Stack>
          <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px"
                }}>
           <Typography sx={{
                    fontSize: "16px"
                  }}>
            <span>
             Program Start Date <span className="migrated-style-closureform-318e74-9">*</span>
            </span>
            <HtmlTooltip arrow title={<React.Fragment>
               <p>Specify the start date.</p>
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-closureform-318e74-10" />
            </HtmlTooltip>
           </Typography>
           <input type="date" className="maindate migrated-style-closureform-318e74-11"
                  // min={today}
                  disabled={value == null || value == "yes" && campaign == 0 ? true : false} readOnly={value == "yes" && campaign != 0 && startDatesClosure != "" ? true : false} onChange={event => {
                    setStartDatesClosure(event.target.value);
                    setIsClosureMailGenerated("init");
                  }} value={startDatesClosure} onKeyDown={e => e.preventDefault()} />
          </Stack>
         </div>
         <div className="mail-form-inner-wrap">
          <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px"
                }}>
           <Typography sx={{
                    fontSize: "16px"
                  }}>
            <span>
             Program End Date <span className="migrated-style-closureform-318e74-12">*</span>
            </span>
            <HtmlTooltip arrow title={<React.Fragment>
               <p>Specify the end date.</p>
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-closureform-318e74-13" />
            </HtmlTooltip>
           </Typography>
           <input type="date" className="maindate migrated-style-closureform-318e74-14" min={startDatesClosure} disabled={value == null || value == "yes" && campaign == 0 ? true : false} readOnly={value == "yes" && campaign != 0 && endDatesClosure != "" ? true : false} onChange={event => {
                    setEndDatesClosure(event.target.value);
                    setIsClosureMailGenerated("init");
                  }} value={endDatesClosure} onKeyDown={e => e.preventDefault()} />
          </Stack>
         </div>
         {/* <div className="mail-form-inner-wrap"> */}
         <Stack className="mail-form-headers" sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px"
              }}>
          <Typography sx={{
                  fontWeight: "400",
                  fontSize: "16px"
                }}>
           <span>
            Key Message/Highlights
            <span className="migrated-style-closureform-318e74-15">*</span>
           </span>
           <HtmlTooltip arrow title={<React.Fragment>
              {categoryNameClosure == "Program" ? <p>
                Provide key details/highlights of the program (e.g., completion
                details/numbers, testimonials, program outcome, program stakeholders).
               </p> : categoryNameClosure == "Event" ? <p>
                Provide key details/highlights of the event (e.g., completion
                details/numbers, testimonials, event outcome, event stakeholders).
               </p> : <p>
                Provide key details/highlights of the webinar (e.g., completion
                details/numbers, testimonials, webinar outcome, webinar stakeholders).
               </p>}
             </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-closureform-318e74-16" />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField
                //placeholder="Key Highlights"
                placeholder={categoryNameClosure == "Program" ? "e.g: Announcing the successful completion of the program." : categoryNameClosure == "Event" ? "e.g: Announcing the successful completion of the event." : "e.g: Announcing the successful completion of the webinar."} id="multiline" multiline minRows={3} disabled={value == null || value == "yes" && campaign == 0 ? true : false} InputLabelProps={{
                  shrink: false
                }} onChange={event => {
                  setKeyMsgClosure(event.target.value);
                  setIsClosureMailGenerated("init");
                }} fullWidth
                //    value={keyPoints}
                value={keyMsgClosure} />
         </Stack>
         <Stack className="mail-form-headers" sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px"
              }}>
          <Typography sx={{
                  fontWeight: "400",
                  fontSize: "16px"
                }}>
           <span>Additional Links/Resources</span>
           <span className="migrated-style-closureform-318e74-17"></span>
           <HtmlTooltip arrow title={<React.Fragment>
              <p>Enter additional links/resources if any.</p>
             </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-closureform-318e74-18" />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField placeholder={categoryNameClosure == "Program" ? "e.g: Program Snapshots/Moments." : categoryNameClosure == "Event" ? "e.g: Event Snapshots/Moments." : "e.g: Webinar Snapshots/Moments."} id="multiline" multiline minRows={3} disabled={value == null || value == "yes" && campaign == 0 ? true : false} InputLabelProps={{
                  shrink: false
                }} onChange={event => {
                  setAdditionalResourcesClosure(event.target.value);
                  setIsClosureMailGenerated("init");
                }}
                // sx={{ width: "20rem" }}
                fullWidth value={additionalResourcesClosure} />
         </Stack>
         {/* </div> */}
        </div>
       </div>
       <div className="btn-container">
        {isClosureNavigatedToForm && <button className="reset-btn" onClick={() => {
              setIsClosureMailGenerated("generateOutput");
              setIsClosureGenerationClicked(true);
            }}>
          Next
         </button>}

        {programNameClosure == "" || keyMsgClosure == "" || startDatesClosure == undefined || endDatesClosure == undefined || isClosureMailGenerated !== "init" ? <div className="mailer-generate-btn-disable">
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div> : <div className="mailer-generate-btn" onClick={() => {
              handleClosureMailGeneration();
              setIsClosureMailGenerated("generateOutput");
              dispatch(handleClosureLoading());
            }}>
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div>}
       </div>
      </Stack>
     </Stack>
    </Stack> : isClosureMailGenerated == "generateOutput" ? <>
     <ClosureDataDisplay setIsClosureGenerationClicked={setIsClosureGenerationClicked} categoryNameClosure={categoryNameClosure} mailerChild={mailerChild} mailerParent={mailerParent} handleReset={handleReset} setIsClosureNavigatedToForm={setIsClosureNavigatedToForm} setIsClosureMailGenerated={setIsClosureMailGenerated} programNameClosure={programNameClosure} />
    </> : <></>}
  </>;
};
export default ClosureForm;
